module.exports = __webpack_public_path__ + "img/params_phone.68d7dbee.png";